module.exports = __webpack_public_path__ + "img/american-express-dark_x2.e0bfdfa0.svg";